import { render } from "./PassChanged.vue?vue&type=template&id=548f7dd3&scoped=true"
import script from "./PassChanged.vue?vue&type=script&lang=js"
export * from "./PassChanged.vue?vue&type=script&lang=js"

import "./PassChanged.vue?vue&type=style&index=0&id=548f7dd3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548f7dd3"]])

export default __exports__